import transferClientsReducer from './clients';
export * from './clients';

export default { transferClients: transferClientsReducer };
